import constants from "@/utils/constants";

export const findCurrentMerchantAccount = (account) => {
  const xMerchantID = localStorage.getItem(constants.X_MERCHANT_ID);
  if (account) {
    return account.merchantAccounts.find(
      (ma) => ma.merchant.identifier === xMerchantID,
    );
  }
  return null;
};

export const isAdmin = (account) => {
  if (account) {
    const currentMerchantAccount = findCurrentMerchantAccount(account);
    return (
      currentMerchantAccount &&
      (currentMerchantAccount.roles.includes("is_admin") ||
        currentMerchantAccount.roles.includes("is_super_admin"))
    );
  }
  return false;
};

export const isSuperAdmin = (account) => {
  if (account) {
    const currentMerchantAccount = findCurrentMerchantAccount(account);
    return (
      currentMerchantAccount &&
      currentMerchantAccount.roles.includes("is_super_admin")
    );
  }
  return false;
};
